module.exports = __webpack_public_path__ + "static/img/wangxian_2x.cfc481a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxian_2x.png
// module id = adNM
// module chunks = 1